/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_UiInputs */

const en_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const ar_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#واجهة`)
};

const bn_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const de_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const es_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const fr_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const pt_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const zh_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const tr_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const ru_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

const pl_svtag_ui = /** @type {(inputs: Svtag_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UI`)
};

/**
* | output |
* | --- |
* | "#UI" |
*
* @param {Svtag_UiInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_ui = /** @type {((inputs?: Svtag_UiInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_UiInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_ui(inputs)
	if (locale === "bn") return bn_svtag_ui(inputs)
	if (locale === "de") return de_svtag_ui(inputs)
	if (locale === "es") return es_svtag_ui(inputs)
	if (locale === "fr") return fr_svtag_ui(inputs)
	if (locale === "pt") return pt_svtag_ui(inputs)
	if (locale === "zh") return zh_svtag_ui(inputs)
	if (locale === "tr") return tr_svtag_ui(inputs)
	if (locale === "ru") return ru_svtag_ui(inputs)
	if (locale === "pl") return pl_svtag_ui(inputs)
	return en_svtag_ui(inputs)
});